// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2IKc8","label":"Category_label__1iLOf","content":"Category_content__3uKG2","header":"Category_header__hcsYI","location":"Category_location__2hNCq"};